import { Injectable } from '@angular/core';
import {
  ActivatedRoute,
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  CanLoad,
  Route,
  Router,
  RouterStateSnapshot,
  UrlSegment,
  UrlTree,
} from '@angular/router';
import { AbcCore, Routing } from '@barthauer/abc/core';
import { catchErrorAndRethrow } from '@barthauer/abc/core/error-handling';
import { Observable } from 'rxjs';
import { concatMap } from 'rxjs/operators';
import { AbcProfileSelectionComponentInfo } from '../..';
import { AuthenticationInterceptor } from '../interceptor/interceptor';
import { LoginComponentInfo } from '../login/login-component-info';
import { ProfileService } from './profile.service';
import { UserService } from './user.service';

@Injectable()
export class ProfileSelectionGuardService implements CanActivate, CanActivateChild, CanLoad {
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private userService: UserService,
    private profileService: ProfileService,
    private abcCore: AbcCore
  ) {}
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.userService.isCurrentlyLoggedInOrAnonymousAllowed.pipe(
      concatMap(async (isAuthenticated) => {
        // console.log(' ---------------------------------------------------------------------- ');

        // console.log('isAuthenticated ==> ', isAuthenticated);

        if (!isAuthenticated) {
          AuthenticationInterceptor.notifyUrl();
          return this.userService.createLoginPageUrlTree(this.router, this.route);
        } else if (this.profileService.areProfilesSupported(this.router)) {
          //console.log('profile supported ==> ');

          if (!(await this.profileService.hasCurrentProfile.toPromise())) {
            const profileInfos = await this.profileService.getProfilesForCurrentUser().toPromise();
            //console.log('profileInfos ==> ', profileInfos);

            AuthenticationInterceptor.notifyUrl();
            if (profileInfos && profileInfos.length === 1) {
              //console.log('one ==> ');

              await this.profileService.setCurrentProfile(profileInfos[0]).toPromise();
              //AuthenticationInterceptor.reload();
            } else {
              // const forwardTo: string = null; // state.url;
              //const res = this.profileService.createProfileSelectionPageUrlTree(this.router, this.route, forwardTo);
              const profileSelectionPageRoute: Route = Routing.findRoute(
                this.router.config,
                AbcProfileSelectionComponentInfo.ROUTE_PATH,
                AbcProfileSelectionComponentInfo.ROUTE_MARKER_TAG
              );

              //console.log('two or more ==> ', profileSelectionPageRoute);
              // return res;

              return this.router.createUrlTree([`/${profileSelectionPageRoute.path}`], {});
            }
          } else {
            this.abcCore.objectSpace.ensureInitialized();
            if (LoginComponentInfo.isCurrentPageLoginPage(this.router)) {
              AuthenticationInterceptor.reload();
            }
          }
        }
        AuthenticationInterceptor.resetUrl();
        //console.log('reached the end ==> ');

        return true;
      }),
      catchErrorAndRethrow((err) => {
        //console.log('err ==> ', err);

        return this.abcCore.error.publish(err);
      })
    );
  }

  canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return true;
  }

  canLoad(route: Route, segments: UrlSegment[]): Observable<boolean> | Promise<boolean> | boolean {
    return true;
  }
}
